<template>
  <div class="enterprise">
    <el-row class="enterprise-map">
      <el-col :span="24">
        <!-- 地图 -->
        <div class="map" id='readmeMap'></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="enterprise-title">
          <span class="cross"></span>
          <span class="title-name bold">物流企业查询</span>
          <span class="cross"></span>
        </div>
      </el-col>
    </el-row>
    <div class="com-box w1400">
      <el-row>
        <el-col :span="6">
          <div class="search">
            <el-input placeholder="请输入内容" v-model="input2">
              <el-button slot="append" icon="el-icon-search" @click='search'></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <el-row class="border">
        <el-col :span="8">
          <ul class="right-list" v-infinite-scroll="load">
            <li v-for="(item,i) in componyData" :class="[comIndex==i?'isActive ullist':'ullist']"
                @click="changeComIndex(i)">
              <div class="font16 cleartext">{{ item.ta002 }}</div>
              <div class="font16 text-r">...</div>
              <div class="font16">
                <span class="cleartext">电话：{{ item.ta004 }}</span>
                <!-- <span class="ml64 cleartext">地址：{{item.ta005}}</span> -->
              </div>
            </li>
          </ul>
        </el-col>
        <el-col :span="16">
          <div class="com-inf">
            <div>
              <img src="../../assets/compony.png" alt="">
            </div>
            <div class="com-name">
              <div class="font16 mt28 pl18 cleartext">企业名称: {{ resource.ta002 }}</div>
              <div class="font16 mt28 pl18">联系电话: {{ resource.ta004 }}</div>
              <div class="font16 mt28 pl18 cleartext">企业位置: {{ resource.ta005 }}</div>
              <div class="font16 mt28 pl18">官网: {{ resource.ta025 }}</div>
            </div>
          </div>
          <div class="com-text">
            <div class="bold font16">
              详情
            </div>
            <div class="moretext font16">
              {{ resource.ta024 }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <MapWay :drawer.sync='drawer' :destination='itemClick'></MapWay>
  </div>
</template>

<script>
import Gmap from "../../public/Gmap";
import MapWay from "../common/mapWay.vue"

export default {
  mixins: [Gmap],
  components: {
    MapWay,
  },
  data() {
    return {
      input2: '',
      //map
      map: '',
      markers: [],
      //数据
      resource: {},
      componyData: [],
      comIndex: 0
    }
  },
  mounted() {
    //初始化地图标价
    this.initMap();

    (async () => {
      let local = await this.getCarMarkerData();
      // this.componyData = local;
      this.resource = local[0];
      local.forEach((ele, i) => {
        ele.ta008 = ele.ta008.split(',');
        this.initMarker(ele, i)
      })
      //给marker添加信息窗体
      local.forEach((ele, i) => {
        if (ele.ta007 != '') {
          ele.ta007 = JSON.parse(ele.ta007)
        }
        this.initMapInfo(this.markers[i], ele);
      })
    })()
  },
  watch: {
    input2() {
      if (this.input2.trim().length < 1) {
        this.getCarMarkerData();
      }
    }
  },
  methods: {
    search() {
      this.$axios.post('/api/company/search', {
        skip: 0,
        pageSize: 100,
        word: this.input2
      }).then(res => {
        this.componyData = res.data.data;
      })
    },
    initMarker(postion, ind) {
      // 创建一个 Icon
      let icon = new AMap.Icon({
        size: new AMap.Size(24, 30),
        // 图标的取图地址
        image: require("../../assets/qy.png"),
        // 图标所用图片大小
        imageSize: new AMap.Size(24, 30),

      });
      let markerContent = `<div style='position:relative;'>
                                  <img src='http://file.sywlfz.com/sylink/images/car.png' style='width:24px;height:30px;' />
                                  <span style='color:#a52a2a;position:absolute;left:10px;top:-15px;'>${ind}</span>
                            </div>`;
      //自定义marker
      let marker = new AMap.Marker({
        map: this.map,
        position: postion.ta008,
        icon: icon,
        // content: markerContent,
        // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
        offset: new AMap.Pixel(-13, -30)
      });
      this.markers.push(marker);
      //添加maerkers 到地图
      this.map.add([marker]);
    },
    initMapInfo(marker, info) {
      //实例化信息窗体
      let infoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: createInfoWindow(info),
        offset: new AMap.Pixel(16, -45)
      });
      //鼠标点击marker弹出自定义的信息窗体
      AMap.event.addListener(marker, 'mouseover', () => {
        infoWindow.open(this.map, marker.getPosition());
      });
      AMap.event.addListener(marker, 'click', (res) => {
        this.itemClick = info.ta008;
        this.drawer = true;
      });
      AMap.event.addListener(marker, 'mouseout', () => {
        this.map.clearInfoWindow();
      });

      //构建自定义信息窗体
      function createInfoWindow(content) {
        let href;
        if (Array.isArray(content.tg011) && content.tg011.length == 2) {
          href = `https://gaode.com/regeo?lng=${content.tg011[0]}&lat=${content.tg011[1]}&name=&adcode=`;
        } else {
          href = "https://gaode.com/regeo?lng=110.79&lat=32.65&name=&adcode=";
        }
        let info = document.createElement("div");
        info.style.backgroundColor = "#F8F8F8";
        info.style.width = '318px';
        info.style.borderRadius = '0 0 4px 4px';
        info.style.marginBottom = '-25px';
        //init title
        content.ta007 = content.ta007 ? content.ta007 : 'http://file.sywlfz.com/sylink/images/effe9b.png';
        info.innerHTML =
          `
                        <div class="carinfo" style="display: flex;flex-wrap: nowrap;align-items: center;height: 96px;padding: 6px 0 7px 8px;">
                            <img src="${content.ta007}" style='display: block;width: 83px;height: 83px;margin-right: 8px;border-radius: 2px;'>
                            <div style='font-size: 14px; color: #666;height:83px display: flex;flex-direction: column;align-content: space-between;'>
                                <div style='margin-bottom: 8px;'>公司名称:${content.ta002}</div>
                                <div style='margin-bottom: 8px;'>联系电话:${content.ta004 ? content.ta004 : ''}</div>
                                <a href="${href}" target="_blank">点击此处导航(或者点击小图标)</a>
                            </div>
                        </div>`;

        return info;
      }
    },

    // getIndexData() {
    //   return new Promise((resolve, reject) => {
    //     this.$axios.post("/api/screen/data", {}).then(res => {
    //       resolve(res.data.data)
    //     }).catch(() => {
    //       reject();
    //     })
    //   })
    // },
    getCarMarkerData() {
      return new Promise((resolve, reject) => {
        this.$axios.post('/api/company/list', {
          where: ' and ta021= 1 and isdelete =0'
        }).then(res => {
          this.componyData = res.data.data;
          resolve(res.data.data)
        }).catch(() => {
          reject();
        })
      })
    },
    changeComIndex(i) {
      this.comIndex = i;
      this.resource = this.componyData[i];
    }
  },
  filters: {
    fromaDate(time) {
      let date = new Date();
      let hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
      let minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
      let seconds = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
      return hours + ':' + minutes + ':' + seconds;
    }
  }
}
</script>
<style scoped>
.enterprise {
  width: 100%;
  color: #333333;
}

.map {
  width: 100%;
  height: 77.1rem;
}

.search {
  margin-bottom: 3.2rem;
}

.enterprise-title {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  margin-top: 3.2rem;
  margin-bottom: 3.5rem;
}

.title-name {
  margin: 0 2.4rem;
  font-size: 3.2rem;
}

.cross {
  display: block;
  width: 2.1rem;
  height: 0.3rem;
  border-radius: 0.2rem;
  background-color: #333333;

}

.com-box {
  overflow: hidden;
  /*margin: 0 26rem;*/
}

.border {
  min-height: 59.3rem;
  border: 1px solid #DCDCDC;
  margin-bottom: 8.4rem;

}

.right-list {
  width: 100%;
  height: 59.3rem;
  overflow: auto;
}

.ullist {
  box-sizing: border-box;
  /* height: 9.5rem; */
  padding: 1.6rem 3.2rem 1.6rem 1.6rem;
  margin-bottom: 0.8rem;
  background-color: #F8F8F8;
}

.ml64 {
  margin-left: 6.4rem;
}

.text-r {
  text-align: right;
}

.isActive {
  background-color: #DCDCDC;
}

.com-inf {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  background-color: #F8F8F8;
  padding-bottom: 0.9rem;
}

.com-inf img {
  display: block;
  width: 30.5rem;
  height: 28.3rem;
  margin-right: 0.9rem;
}

.com-name {
  flex: 1;
  background-color: white;
}

.com-text {
  padding: 1.6rem 2.4rem;
  background-color: white;
}

.mt28 {
  margin-top: 2.8rem;
}

.pl18 {
  padding-left: 1.8rem;
}

.moretext {
  margin-top: 1.5rem;
  color: #9B9B9B;
}
</style>



// WEBPACK FOOTER //
// src/components/page/enterprise.vue